<template>
  <div class="security-tip space-between" :class="[displayLayout, isNewClass]">
    <span class="iconfont icon-bg-security"></span>
    <span>{{ tip }}</span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SecurityTip',
    props: {
      tip: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['displayLayout', 'isNewClass']),
    },
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
  }
</script>

<style lang="scss" scoped src="./index.scss"></style>
